/**
 * BOTTOM GENERAL INITS
 * STRUCTURE
 */

import { Advertising } from "./advertising";
import { AdvetisingPlayer } from "./advetisingPlayer";


export class AdvertisingInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new Advertising();
        new AdvetisingPlayer();
    }
}
